import { render, staticRenderFns } from "./CardPreviewContent.vue?vue&type=template&id=5f63b1a5&scoped=true&"
import script from "./CardPreviewContent.vue?vue&type=script&lang=js&"
export * from "./CardPreviewContent.vue?vue&type=script&lang=js&"
import style0 from "./CardPreviewContent.vue?vue&type=style&index=0&id=5f63b1a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f63b1a5",
  null
  
)

export default component.exports